import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@pella/sash-framework';
import { CTA, Image, Video } from '../../../';
import { isValidArray } from '../../../utilities/validations';

const HomepageHero = ({ data, className, ...other }) => (
	<div
		className={`homeHero bg-black ${className || ''}`}
		id='homepage-hero'
		{...other}
	>
		<Container className='homeHero-container flex flex-col max-sm:px-0 sm:flex-row-reverse sm:!pr-0'>
			{isValidArray(data.image) && (
				<Image
					data={data.image[0]}
					loading='eager'
					className='homeHero-image flex-1 [&>div]:h-full'
				/>
			)}

			{isValidArray(data.video) && (
				<Video
					data={data.video[0]}
					className='homeHero-video flex-1 [&>div]:h-full [&_video]:object-cover'
					videoAttributes={{ controls: true }}
					youtube={false}
				/>
			)}

			<div className='homeHero-content flex flex-col justify-center py-6 max-sm:px-6 sm:w-[49%] sm:pr-4 md:py-8 xl:w-2/5 xl:py-5'>
				{data.file?.url && (
					<Image
						data={{ image: data.file }}
						className='homeHero-icon mb-4 w-[150px] md:mb-3 xl:mb-8'
					/>
				)}

				{data.heading && (
					<h1
						className='homeHero-heading text-h2 !mb-0 text-white'
						dangerouslySetInnerHTML={{ __html: data.heading }}
					/>
				)}
				{data.description && (
					<div
						className='homeHero-description text-subtitle mb-4 mt-2 text-white sm:mb-3 xl:mb-8'
						dangerouslySetInnerHTML={{
							__html: data.description,
						}}
					/>
				)}
				{isValidArray(data.cta) && (
					<CTA
						className='homeHero-cta sm:w-fit'
						data={data.cta[0]}
					/>
				)}
			</div>
		</Container>
	</div>
);

HomepageHero.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default HomepageHero;
